var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"loading":_vm.isLoading,"loading-text":"Loading... Please wait","items":_vm.data},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{
          path: '/client/reports',
          query: {
            name: item.name,
            type: _vm.type,
            dealerId: _vm.dealerId,
            specificDealerId:
              _vm.specificDealerId === '0' ? item.id : _vm.specificDealerId,
          },
        }}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }